import { BaseQueryFn, EndpointBuilder, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { Document } from 'services/documents/types/dtos';
import { APP_ENDPOINTS } from 'app/endpoints';
import { ProductCategory, ResponseProductCategoryDto } from '../types/dtos';

type LogoType = 'original' | 'medium' | 'thumbnail' | 'small';

const extractLogo = (logo: Document, type: LogoType) => JSON.parse(logo.filePaths)[type];

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<ProductCategory, string>({
        async queryFn(productCategoryId, _queryApi, _extraOptions, fetchWithBQ) {
            const productCategoryResult = await fetchWithBQ(`${APP_ENDPOINTS.PRODUCT_CATEGORY}/${productCategoryId}`);

            if (productCategoryResult.error) return { error: productCategoryResult.error as FetchBaseQueryError };

            const productCategory = productCategoryResult.data as ResponseProductCategoryDto;

            if (productCategory.documentId) {
                const documentResult = await fetchWithBQ(`${APP_ENDPOINTS.DOCUMENT}/${productCategory.documentId}`);
                if (documentResult.error) return { error: documentResult.error as FetchBaseQueryError };
                const document = documentResult.data as Document;
                return {
                    data: { ...productCategory, logo: extractLogo(document, 'small') },
                };
            }
            return {
                data: productCategory,
            };
        },
        providesTags: [{ type: 'product-category', id: 'GET-ID' }],
    });
